<h1 mat-dialog-title>{{ 'MANAGEMENT.CATCH_UP_DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'MANAGEMENT.CATCH_UP_DIALOG.MESSAGE' | translate }}</p>
  <mat-checkbox [(ngModel)]="deleteAfterIngest">
    {{ 'MANAGEMENT.CATCH_UP_DIALOG.DELETE_AFTER_INGEST' | translate }}
  </mat-checkbox>
</div>
<div mat-dialog-actions align="end">
  <button type="button" mat-button (click)="onCancel()">{{ 'MANAGEMENT.CATCH_UP_DIALOG.CANCEL' | translate }}</button>
  <button type="button" mat-flat-button color="primary" (click)="onConfirm()">{{ 'MANAGEMENT.CATCH_UP_DIALOG.OK' | translate }}</button>
</div>
